import Component from "./OrderDetail";
export default Component;
